sap.ui.requireSync("sap/ui/integration/customElements/CustomElementCardEditor");
